import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { forkJoin } from 'rxjs';
import { SuperAdminService } from 'src/app/super-admin.service';

@Component({
  selector: 'app-invoice-preview',
  templateUrl: './invoice-preview.component.html',
  styleUrls: ['./invoice-preview.component.css']
})
export class InvoicePreviewComponent implements OnInit {
  checkInvoiceType: any = 'Ad Hoc';
  isAdHoc: boolean = false;
  invtot: number = 0;
  tooltaxPaidtot: number = 0;
  clientName: any;
  extrahour: number = 0;
  kmtot: number = 0;
  totLabourLoad: number = 0;
  totLabourUnload: number = 0;
  totDetention: number = 0;
  vehicles: any;
  clientList = [];
  particlarLR: any;
  users: any = [];
  paramId: any;
  billno: string = '';
  Frieght: number = 0;
  transporterName: string = '';
  transporterAddress: string = '';
  transporterGstNo: string = '';
  otherPayment: number = 0;
  isEditing: boolean = false;
  isSaving: boolean = false;
  backupUsers: any = [];
  totalAmountInAdhoc: number = 0;
  constructor(
    public dialogRef: MatDialogRef<InvoicePreviewComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private superAdminService: SuperAdminService,
    private toastr: ToastrService
  ) {
    this.getParticularInvoice("");
  }

  ngOnInit(): void { }

  getParticularInvoice(id: string) {
    let rawdata: any[] = [];
    const source = this.data?.invoiceData !== undefined
      ? this.data.invoiceData
      : (this.data?.data !== undefined ? this.data.data : this.data);

    if (Array.isArray(source)) {
      rawdata = source;
    } else if (source && typeof source === 'object') {
      rawdata = [source];
    } else {
      rawdata = [];
    }

    const firstRecord = rawdata[0] || {};

    // Invoice type nikalna
    const rawInvType = this.data?.invoiceType
      || firstRecord?.invoiceType
      || firstRecord?.invoiceTypeName
      || (Array.isArray(firstRecord?.invoice?.[0]?.invoiceTypeName) ? firstRecord?.invoice?.[0]?.invoiceTypeName?.[0] : firstRecord?.invoice?.[0]?.invoiceTypeName)
      || (Array.isArray(firstRecord?.invoice?.[0]?.fixAdhoc) ? firstRecord?.invoice?.[0]?.fixAdhoc?.[0] : firstRecord?.invoice?.[0]?.fixAdhoc)
      || firstRecord?.fixAdhoc
      || firstRecord?.invoice?.[0]?.invoiceType
      || '';

    // Supports both new DB values ('Ad Hoc' / 'Fixed') and legacy values ('Type1' / 'Type2')
    this.isAdHoc = /adhoc/i.test(rawInvType)
      || /ad hoc/i.test(rawInvType)
      || rawInvType === 'Type1'
      || rawInvType === 'Type 1'
      || !rawInvType;

    this.checkInvoiceType = rawInvType || (this.isAdHoc ? 'Ad Hoc' : 'Fixed');

    this.billno = firstRecord?.billno || firstRecord?.billNo || '';

    // Users set karna
    const rawInvoice = firstRecord?.invoice || firstRecord?.invoiceData;
    if (Array.isArray(rawInvoice)) {
      this.users = rawInvoice;
    } else if (rawInvoice && typeof rawInvoice === 'object') {
      this.users = [rawInvoice];
    } else if (Array.isArray(firstRecord)) {
      this.users = firstRecord;
    } else {
      this.users = [];
    }

    // Ensure manual entry arrays are initialized
    this.users.forEach((user: any) => {
      if (!user) return;
      const lrCount = Array.isArray(user.LR_no) ? user.LR_no.length : (user.LR_no ? 1 : 0);
      if (!Array.isArray(user.labourLoad)) user.labourLoad = new Array(lrCount).fill(0);
      if (!Array.isArray(user.labourUnload)) user.labourUnload = new Array(lrCount).fill(0);
      if (!Array.isArray(user.detention)) user.detention = new Array(lrCount).fill(0);
    });

    this.Frieght = Array.isArray(this.users[0]?.Frieght)
      ? this.users[0]?.Frieght?.[0]
      : (this.users[0]?.Frieght || '');

    // Totals calculate karna
    this.recalculateTotals();
    this.loadTransporterDetails();
  }

recalculateTotals() {
  this.kmtot = 0;
  this.extrahour = 0;
  this.tooltaxPaidtot = 0;
  this.invtot = 0;
  this.totLabourLoad = 0;
  this.totLabourUnload = 0;
  this.totDetention = 0;
  this.Frieght = 0;
  this.otherPayment = 0;

  if (!Array.isArray(this.users)) return;

  this.users.forEach((user: any) => {
    if (!user) return;

    this.invtot += (Array.isArray(user.vehicleRate) ? user.vehicleRate : [])
      .reduce((a: number, b: any) => a + Number(b || 0), 0);

    this.kmtot += (Array.isArray(user.up_down_km) ? user.up_down_km : [])
      .reduce((a: number, b: any) => a + Number(b || 0), 0);

    this.extrahour += (Array.isArray(user.extrahour) ? user.extrahour : [])
      .reduce((a: number, b: any) => a + Number(b || 0), 0);

    this.tooltaxPaidtot += (Array.isArray(user.tooltaxPaid) ? user.tooltaxPaid : [])
      .reduce((a: number, b: any) => a + Number(b || 0), 0);

    this.totLabourLoad += (Array.isArray(user.labourLoad) ? user.labourLoad : [])
      .reduce((a: number, b: any) => a + Number(b || 0), 0);

    this.totLabourUnload += (Array.isArray(user.labourUnload) ? user.labourUnload : [])
      .reduce((a: number, b: any) => a + Number(b || 0), 0);

    this.totDetention += (Array.isArray(user.detention) ? user.detention : [])
      .reduce((a: number, b: any) => a + Number(b || 0), 0);

    this.otherPayment += (Array.isArray(user.otherPayment) ? user.otherPayment : [])
      .reduce((a: number, b: any) => a + Number(b || 0), 0);

    this.Frieght += (Array.isArray(user.Frieght) ? user.Frieght : [])
      .reduce((a: number, b: any) => a + Number(b || 0), 0);
  });

  console.log('Totals:', {
    Frieght: this.Frieght,
    otherPayment: this.otherPayment,
    invtot: this.invtot,
    totLabourLoad: this.totLabourLoad,
    totLabourUnload: this.totLabourUnload,
    totDetention: this.totDetention
  });

  if (this.isAdHoc) {
    this.totalAmountInAdhoc =
      this.totDetention +
      // this.invtot +
      this.totLabourLoad +
      this.totLabourUnload +
      this.Frieght +
      this.otherPayment;

    console.log('totalAmountInAdhoc:', this.totalAmountInAdhoc);
  }
}

  loadTransporterDetails() {
    const firstUser = this.users[0];
    if (!firstUser) {
      this.transporterName = 'Radha Swami Transport Service';
      this.transporterAddress = 'N/A';
      this.transporterGstNo = 'N/A';
      return;
    }

    const toArray = (val: any): any[] => {
      if (!val) return [];
      if (Array.isArray(val)) return val;
      if (typeof val === 'string' || typeof val === 'number') return [val];
      return [];
    };

    const rawTransporterNames = toArray(firstUser.transportorName);
    const validTransporterName = rawTransporterNames.find((name: any) =>
      name && name !== '0' && name !== '1' && name !== '-' && String(name).toLowerCase() !== 'n/a'
    ) || (typeof firstUser.transportorName === 'string' ? firstUser.transportorName : '') || '';

    const rawGstins = toArray(firstUser.GSTIN);
    const validGstin = rawGstins.find((gst: any) =>
      gst && gst !== '0' && gst !== '1' && gst !== '-' && String(gst).toLowerCase() !== 'n/a'
    ) || (typeof firstUser.GSTIN === 'string' ? firstUser.GSTIN : '') || '';

    const rawAddresses = [
      ...toArray(firstUser.consignor_address),
      ...toArray(firstUser.consignee_address)
    ];
    const validAddress = rawAddresses.find((addr: any) =>
      addr && addr !== '0' && addr !== '1' && addr !== '-' && String(addr).toLowerCase() !== 'n/a'
    ) || (typeof firstUser.consignor_address === 'string' ? firstUser.consignor_address : '')
      || (typeof firstUser.consignee_address === 'string' ? firstUser.consignee_address : '')
      || '';

    this.transporterName = validTransporterName && validTransporterName !== '0' && validTransporterName !== '1'
      ? validTransporterName
      : 'Radha Swami Transport Service';
    this.transporterAddress = validAddress || 'N/A';
    this.transporterGstNo = validGstin && validGstin !== '0' && validGstin !== '1' ? validGstin : 'N/A';

    this.superAdminService.getAllTransporters(1, 1000).subscribe({
      next: (res: any) => {
        if (res?.status && Array.isArray(res?.data) && res.data.length > 0) {
          const list = res.data;

          const matched = list.find((t: any) => {
            const fullName = (t.user_id?.full_name || '').trim().toLowerCase();
            const tpId = (t.transporter_id || '').trim().toLowerCase();
            const gstin = (t.gstin || '').trim().toLowerCase();

            const targetName = String(validTransporterName).trim().toLowerCase();
            const targetGst = String(validGstin).trim().toLowerCase();

            return (targetName && (fullName === targetName || tpId === targetName)) ||
              (targetGst && gstin === targetGst);
          });

          if (matched) {
            this.setTransporterFromRecord(matched);
            return;
          }

          // Check if vehicle connects to a transporter
          const vehicleNo = Array.isArray(firstUser.vehicle_id) ? firstUser.vehicle_id[0] : firstUser.vehicle_id;
          if (vehicleNo) {
            this.superAdminService.getvehicles().subscribe({
              next: (vRes: any) => {
                if (vRes?.status && Array.isArray(vRes?.data)) {
                  const matchedVehicle = vRes.data.find((v: any) => v.vehicle_no === vehicleNo);
                  if (matchedVehicle && matchedVehicle.transporter) {
                    const t = list.find((item: any) => item._id === matchedVehicle.transporter);
                    if (t) {
                      this.setTransporterFromRecord(t);
                    }
                  }
                }
              },
              error: (err: any) => {
                console.warn("Could not load vehicles for transporter lookup:", err);
              }
            });
          }
        }
      },
      error: (err: any) => {
        console.warn("Error loading transporters:", err);
      }
    });
  }

  private setTransporterFromRecord(t: any) {
    if (t.user_id?.full_name) {
      this.transporterName = t.user_id.full_name;
    }
    if (t.gstin) {
      this.transporterGstNo = t.gstin;
    }
    const addressParts = [
      t.address_line_1,
      t.address_line_2,
      t.city,
      t.state,
      t.pin_code
    ].filter((part: any) => part && String(part).trim().length > 0);

    if (addressParts.length > 0) {
      this.transporterAddress = addressParts.join(', ');
    }
  }

  getFreight(user: any, i: number): string {
    if (user?.Frieght && user.Frieght[i] !== undefined && user.Frieght[i] !== null && user.Frieght[i] !== '') {
      return user.Frieght[i];
    }
    if (user?.freight && user.freight[i] !== undefined && user.freight[i] !== null && user.freight[i] !== '') {
      return user.freight[i];
    }
    return '-';
  }

  getVehicleType(user: any, i: number): string {
    return user?.vehicle_type?.[i] || user?.vehicleType?.[i] || '-';
  }

  enableEdit() {
    this.backupUsers = JSON.parse(JSON.stringify(this.users));
    this.isEditing = true;
  }

  cancelEdit() {
    if (this.backupUsers && this.backupUsers.length > 0) {
      this.users = JSON.parse(JSON.stringify(this.backupUsers));
    }
    this.isEditing = false;
    this.recalculateTotals();
  }

  saveEdit() {
    const updateObservables: any[] = [];

    this.users.forEach((user: any) => {
      const lrCount = (user.LR_no || []).length;
      for (let i = 0; i < lrCount; i++) {
        const lrId = user._id?.[i];
        if (lrId) {
          const payload = {
            labourLoad: Number(user.labourLoad?.[i] || 0),
            labourUnload: Number(user.labourUnload?.[i] || 0),
            detention: Number(user.detention?.[i] || 0),
            otherPayment: Number(user.otherPayment?.[i] || 0),
          };
          updateObservables.push(this.superAdminService.updateLRManualCharges(lrId, payload));
        }
      }
    });

    if (updateObservables.length === 0) {
      this.isEditing = false;
      return;
    }

    this.isSaving = true;
    forkJoin(updateObservables).subscribe({
      next: () => {
        this.isSaving = false;
        this.isEditing = false;
        this.toastr.success("Invoice charges updated successfully");
        this.recalculateTotals();
      },
      error: (err: any) => {
        this.isSaving = false;
        this.toastr.error(err?.error?.message || err?.message || "Failed to update charges");
      }
    });
  }

  declineInvoice() {
    this.dialogRef.close({
      status: "decline",
    });
  }

  approveInvoice() {
    this.dialogRef.close({
      status: "approved",
      billno: this.billno,
      invoiceType: this.checkInvoiceType
    });
  }

  sendInvoice(divName: string) { }
  backTo() { }
}
